var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledForwardArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "disabled forward arrow",
    d: "M8.67619 8.79208L1.88741 15.6716C1.45556 16.1095 0.755395 16.1095 0.323757 15.6716C-0.107917 15.2342 -0.107917 14.5246 0.323757 14.0872L6.33078 7.99988L0.32393 1.91276C-0.107744 1.47513 -0.107744 0.765684 0.32393 0.328226C0.755604 -0.109409 1.45574 -0.109409 1.88759 0.328226L8.67637 7.20786C8.8922 7.4267 9 7.7132 9 7.99985C9 8.28664 8.89199 8.57335 8.67619 8.79208Z",
    fill: "#AEB3BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledForwardArrow);
export default __webpack_public_path__ + "static/media/disabled_forward_arrow.b0729897e7ea96a75bb34a189957bc69.svg";
export { ForwardRef as ReactComponent };